import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { GuidedSellingStepChoice, GuidedSellingStepIconChoice } from "@swo/storefront";
import { pipe } from "fp-ts/pipeable";
import { nonEmptyArray } from "fp-ts";
import { ButtonsListIconChoice } from "./layouts/ButtonsListIconChoice";
import React from "react";

export const VisualGridChoice: ReactTFC<{
  choices: NonEmptyArray<GuidedSellingStepChoice>;
  currentChoice: string | undefined;
  onMakeChoice: (choiceId: string) => void;
  onChoiceHovered: (choice: GuidedSellingStepIconChoice) => void;
}> = props => {
  const elements = pipe(
    props.choices,
    nonEmptyArray.map(choice => {
      const isChecked = choice.id === props.currentChoice;

      return (
        <ButtonsListIconChoice
          key={choice.id}
          onMakeChoice={() => props.onMakeChoice(choice.id)}
          icon={choice.icon}
          label={choice.label}
          isChecked={isChecked}
          value={choice.id}
          variant={"icon-focused"}
          onChoiceHovered={() => props.onChoiceHovered(choice)}
        />
      );
    }),
  );

  return <>{elements}</>;
};
